import { render, staticRenderFns } from "./CostBreakdownCompanySettings.vue?vue&type=template&id=55c2c847&scoped=true&"
import script from "./CostBreakdownCompanySettings.vue?vue&type=script&lang=js&"
export * from "./CostBreakdownCompanySettings.vue?vue&type=script&lang=js&"
import style0 from "./CostBreakdownCompanySettings.vue?vue&type=style&index=0&id=55c2c847&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c2c847",
  null
  
)

export default component.exports